import { createFileRoute } from "@tanstack/react-router";
import { PlatformPage } from "@/components/PlatformPage";
import { erpBaselinker } from "@/lib/integrations-data";
import { buildSeoMeta } from "@/lib/seo";

const PATH = "/integracje/erp-baselinker";

export const Route = createFileRoute("/integracje/erp-baselinker")({
  head: () =>
    buildSeoMeta({
      title: "Integracja Baselinker z ERP — Comarch, Subiekt, Enova, WAPRO | SyncTech",
      description:
        "Integracja Baselinker z systemami ERP: Comarch Optima/XL, Subiekt GT/nexo, Enova365, WAPRO Mag, Symfonia. Automatyczne fakturowanie, synchronizacja magazynu, scenariusze.",
      path: PATH,
    }),
  component: () => (
    <PlatformPage data={erpBaselinker} path={PATH} breadcrumbCategory="Integracje" />
  ),
});
